import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.25 2.25a2.25 2.25 0 0 1-1.5 2.122v.378a1.5 1.5 0 0 0 1.5 1.5 3 3 0 0 1 3 3v.378a2.25 2.25 0 1 1-1.5 0V9.25a1.5 1.5 0 0 0-1.5-1.5A3 3 0 0 1 7 6.734 3 3 0 0 1 4.75 7.75a1.5 1.5 0 0 0-1.5 1.5v.378a2.25 2.25 0 1 1-1.5 0V9.25a3 3 0 0 1 3-3 1.5 1.5 0 0 0 1.5-1.5v-.378a2.25 2.25 0 1 1 3-2.122",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceHierarchyFlowchart = { render };
export {
  interfaceHierarchyFlowchart as default,
  render
};
//# sourceMappingURL=interface-hierarchy-flowchart.svg.js.map
